interface Props {
  className?: string;
}

export const Divider = (props: Props) => {
  const { className } = props;
  return <div className={`block h-px min-h-px w-full rounded-full bg-white-main opacity-30 ${className}`} />;
};
